/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
import '../blocks/elementor/example-widget/index.js'; import '../blocks/elementor/filter-program-widget/index.js'; import '../blocks/elementor/find-program-widget/index.js'; import '../blocks/elementor/post-content-widget/index.js'; import '../blocks/elementor/post-title-widget/index.js';

document.addEventListener('DOMContentLoaded', () => {});

// Function to handle slider autoplay on mobile devices
(function () {
  const MOBILE_BREAKPOINT = 767;

  function handleSlider(container) {
    const slider = container.querySelector('.elementor-background-slideshow');
    if (!slider || !slider.swiper) return;

    if (container.classList.contains('slider-play-always')) return;

    const swiper = slider.swiper;
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    if (isMobile) {
      setTimeout(() => swiper.autoplay && swiper.autoplay.stop(), 200);
      setTimeout(() => swiper.autoplay && swiper.autoplay.stop(), 600);
    } else {
      setTimeout(() => swiper.autoplay && swiper.autoplay.start(), 200);
    }
  }

  function processContainer(container) {
    const slider = container.querySelector('.elementor-background-slideshow');
    if (!slider) return;

    let attempts = 0;

    const interval = setInterval(() => {
      if (slider.swiper) {
        clearInterval(interval);

        handleSlider(container);
        setTimeout(() => handleSlider(container), 400);
      }

      if (++attempts > 50) clearInterval(interval);
    }, 100);
  }

  function run() {
    document.querySelectorAll('.elementor-element').forEach(processContainer);
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(run, 300);
  });
})();
